import { DetailedRound } from "../models/round";
import { PrizeGroups } from "../roundview/components/roundinformation";

export function getNumFixtures(roundName: string): number {
  const groups = PrizeGroups[roundName];
  if (!groups || groups.length === 0) return 0;
  return Math.max(...groups.map(g => g.correct));
}

export function getJackpot(currency: string, detailedRound?: DetailedRound): number | null {

  const jackpotkey = 'jackpot'.concat(currency);

  let jackpotEntry = detailedRound?.promotionalValues?.filter((item) => item.key === jackpotkey) ?? [];

  let jackpot: number | null = null;
  if (jackpotEntry.length === 1) {
    jackpot = jackpotEntry[0].value;
  }
  else {

    jackpotEntry = detailedRound?.promotionalValues?.filter((item) => item.key === 'jackpotEUR') ?? [];
    if (jackpotEntry.length === 1) {

      let jackpotEur = jackpotEntry[0].value;

      switch (currency) {
        case 'SEK': //11,37
        case 'NOK': //11,82
          jackpot = getSekJackpot(jackpotEur);
          break;
        case 'DKK': //7,46
          jackpot = jackpotEur * 7;
          break;
        case 'GHS': //17,38
          jackpot = jackpotEur * 15;
          break;
        case 'MAD': //10,74
          jackpot = jackpotEur * 10;
          break;
        case 'AUD':
        case 'CAD':
        case 'NZD':
        case 'SGD':
        case 'AZN':
          jackpot = jackpotEur * 1.5;
          break;
        case 'BRL':
        case 'PLN':
          jackpot = jackpotEur * 5;
          break;
        case 'INR':
          jackpot = jackpotEur * 80;
          break;
        case 'JPY':
          jackpot = jackpotEur * 130;
          break;
        case 'USD':
        case 'USDT':
        case 'CHF':
          jackpot = jackpotEur;
          break;
        case 'TZS':
          jackpot = jackpotEur * 2000;
          break;
        case 'TRY':
          jackpot = jackpotEur * 30;
          break;
        case 'AMD':
          jackpot = jackpotEur * 400;
          break;
        case 'BYN':
          jackpot = jackpotEur * 3;
          break;
        case 'IRR':
          jackpot = jackpotEur * 600000;
          break;
        case 'IRT':
          jackpot = jackpotEur * 60000;
          break;
        case 'RUB':
          jackpot = jackpotEur * 100;
          break;
        case 'CLP':
          jackpot = jackpotEur * 1000;
          break;
        case 'PEN':
          jackpot = jackpotEur * 4;
          break;
        case 'ETB':
          jackpot = 1000000;
          break;
        default:
          break;
      }
    }
  }

  return jackpot;
}

export function getSekJackpot(jackpotEur: number): number {
  if (jackpotEur < 400000) {
    return jackpotEur * 10;
  }
  if (jackpotEur < 700000) {
    return jackpotEur * 10 + 500000;
  }
  if (jackpotEur < 1100000) {
    return jackpotEur * 10 + 1000000;
  }
  if (jackpotEur < 1400000) {
    return jackpotEur * 10 + 1500000;
  }
  if (jackpotEur < 2000000) {
    return jackpotEur * 10 + 2000000;
  }
  return jackpotEur * 10 + 3000000;
}
